import { useTranslation } from "react-i18next";
import { DIRECTION } from "services/general";

/**
 * MoreToolsPopupMenu — compact dropdown popup shown on tablet/desktop widths
 * (640px - 1023px) when the More Tools trigger is open.
 */
const MoreToolsPopupMenu = ({ moreMenuItems }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`hidden sm:block absolute top-full mt-2 ${
        DIRECTION === "rtl" ? "left-0" : "right-0"
      } w-[220px] bg-surface rounded-xl shadow-lg border border-border-light z-[100] overflow-hidden`}
    >
      <div className="px-4 py-3 border-b border-border-light">
        <span className="text-sm text-text-muted font-medium">
          {t("more_tools")}
        </span>
      </div>

      <div className="py-2">
        {moreMenuItems?.map((item) => (
          <button
            key={item.id}
            onClick={item.onClick}
            className="w-full flex items-center gap-3 px-4 py-3 hover:bg-surface-muted transition-colors border-0 bg-transparent cursor-pointer text-start"
          >
            <span className="shrink-0">{item.icon}</span>
            <span className="text-sm text-[#060606] dark:text-white font-medium">
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MoreToolsPopupMenu;
